import axios from "axios";
import baseUrl from "./base-url";
import { getValidUrl } from "../util";

export default function({ state, dispatch }, { url, query }) {
  // Insert query parameters into query
  if (query) {
    url =
      url +
      "?" +
      Object.keys(query)
        .map((q) => q + "=" + query[q])
        .join("&");
  }

  url = getValidUrl(url, state);

  return axios
    .get(baseUrl + url, {
      withCredentials: true,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (
        error.response.status &&
        error.response.status === 403 &&
        error.response.data &&
        error.response.data.code === "ConditionalJWT"
      )
        dispatch("auth/logout", null, { root: true }).then(
          () => (window.location.href = "/login")
        );
      throw error.response.data;
    });
}
